<div class="avatar-box" [style.width.px]="width" [style.height.px]="height" [class.round]="isAvatar">
    <nb-user size="small" name="{{userFullName}}" onlyPicture [class.cursor-pointer]="cursorPointer" *ngIf="!isAvatar" [style.font-size.px]="fontSizeInPx">
    </nb-user>

    <!-- <img [srcset]="avatarUrl" alt="" [class.cursor-pointer]="cursorPointer" *ngIf="isAvatar" (error)="onImgError()"> -->
</div>